import { useEffect } from 'react';
import './useScrollReveal.css';

export const useScrollReveal = () => {
  useEffect(() => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { 
        threshold: isMobile ? 0.02 : 0.12, 
        rootMargin: isMobile ? '0px 0px -10px 0px' : '0px 0px -60px 0px' 
      }
    );

    const elements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  });
};
